export enum ManagementState {
    ManagedApplication = 'managedApplication',
    UnmanagedApplication = 'unmanagedApplication',
    UnclassifiedApplication = 'unclassifiedApplication'
}
